import React from 'react';

import Carteira from '../Carteira';

const Home = () => {
    return (
        <div>
            <Carteira />
        </div>
    );
};

Home.propTypes = {};

export default Home;
